module.exports = __webpack_public_path__ + "static/media/notification-black-icon.d1851434.svg";